/**
 * Run timer.
 *
 * The result is derived from the *number of fixed simulation steps*, never from
 * the frame count and never from the wall clock. `steps / SIMULATION_HZ` is
 * exactly reproducible, so two identical runs produce byte-identical times.
 */

import { SIMULATION_HZ } from '../config/gameplay';

export class RunTimer {
  private steps = 0;

  reset(): void {
    this.steps = 0;
  }

  /** Called once per fixed simulation step, and only while RUNNING. */
  advance(): void {
    this.steps++;
  }

  get stepCount(): number {
    return this.steps;
  }

  /** Simulation time in seconds. This is the clock the whole game runs on. */
  get seconds(): number {
    return this.steps / SIMULATION_HZ;
  }

  get milliseconds(): number {
    return Math.round((this.steps * 1000) / SIMULATION_HZ);
  }
}
